// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GeneratePdfFromHtmlRequest {
    static getAttributeTypeMap() {
        return GeneratePdfFromHtmlRequest.attributeTypeMap;
    }
}
GeneratePdfFromHtmlRequest.discriminator = undefined;
GeneratePdfFromHtmlRequest.additionalProperties = false;
GeneratePdfFromHtmlRequest.attributeTypeMap = [
    {
        "name": "filename",
        "baseName": "filename",
        "type": "string"
    },
    {
        "name": "html",
        "baseName": "html",
        "type": "string"
    },
    {
        "name": "css",
        "baseName": "css",
        "type": "string"
    },
];
//# sourceMappingURL=generatePdfFromHtmlRequest.js.map